module.exports = __webpack_public_path__ + "static/media/Color Prediction.de9fdd66.png";